import { LayoutTypeMetadata, ToLayoutTypeMetadata } from "../layout-type-metadata.enum"
import { MetadataFactory } from "../metadata.factory"
import { LayoutMetadata, LayoutMetadataBase } from "./layout-metadata.model"
import { RepeatLayoutMetadata, RepeatLayoutMetadataBase } from "./repeat-layout-metadata.model"
import { RowLayoutMetadata, RowLayoutMetadataBase } from "./row-layout.metadata.model"
import { TableLayoutMetadata, TableLayoutMetadataBase } from "./table-layout-metadata.model"
import { WebServiceLayoutMetadataBase } from "./webservice-layout-metadata.model"


export class SectionLayoutMetadataBase extends LayoutMetadataBase {


    fieldName: string
    name: string
    items: LayoutMetadataBase[] = []
    hideHeader: boolean = false
    shown: boolean = true
    onFormCreation: boolean = true
    required: boolean = false

    constructor(type: string) {
        super(type)
        this.name = "Secció "
        this.fieldName = this.id
    }

    schema(): any {

        let schema: any = {
            '$schema': 'http://json-schema.org/draft-04/schema#',
            description: 'EACAT form Schema',
            type: 'object',
            refName: this.fieldName,
            properties: {},
            required: []
        }

        for (let row of this.items) {
            if (row instanceof RowLayoutMetadataBase) {
                row.schema(schema)
            } else if (row instanceof RepeatLayoutMetadataBase) {
                row.schema(schema)
            } else if (row instanceof TableLayoutMetadataBase) {
                row.schema(schema)
            } else if (row instanceof WebServiceLayoutMetadataBase) {
                row.schema(schema)
            }
        }

        return schema
    }

    from(layout: LayoutMetadata): void {

        Object.assign(this, layout)

        for (let i = 0; i < this.items.length; i++) {
            const element = this.items[i]
            let type = ToLayoutTypeMetadata(element.type)
            if (type == null) continue

            let item = MetadataFactory.createLayoutFromType(type)
            item.from(element)
            this.items[i] = item
        }
    }

    static getDefaultValue = (metadata: SectionLayoutMetadata): any => {

        let obj: any = {}

        metadata.items.forEach(item => {
            if (ToLayoutTypeMetadata(item.type) == LayoutTypeMetadata.Repeat) {
                let repeat = <RepeatLayoutMetadata> item
                if (repeat.atLeastOne == false) return

                let itemObject: any = {}

                repeat.items.forEach(w => {
                    let row = <RowLayoutMetadata> w;
                    row.items.forEach(widget => {
                        itemObject[widget.fieldName] = widget.defaultValue;
                    })
                })

                obj[repeat.fieldName] = [itemObject]
                return
            }

            if (ToLayoutTypeMetadata(item.type) == LayoutTypeMetadata.Table) {
                let table = <TableLayoutMetadata> item
                if (table.atLeastOne == false) return

                let itemObjet: any = {}

                table.items.forEach(w => {
                    let row = <RowLayoutMetadata> w;
                    row.items.forEach(widget => {
                        itemObjet[widget.fieldName] = widget.defaultValue
                    })
                })

                obj[table.fieldName] = [itemObjet]
                return
            }

            let row = <RowLayoutMetadata> item;
            row.items.forEach(widget => {
                obj[widget.fieldName] = widget.defaultValue
            })
        })

        return obj
    }


}

export interface SectionLayoutMetadata extends SectionLayoutMetadataBase { }